"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationOrigin = void 0;
var ReservationOrigin;
(function (ReservationOrigin) {
    ReservationOrigin["chatbot"] = "chatbot";
    ReservationOrigin["guestWeb"] = "guestWeb";
    ReservationOrigin["guestApp"] = "guestApp";
    ReservationOrigin["authenticatedGuestWeb"] = "authenticatedGuestWeb";
    ReservationOrigin["placeWeb"] = "placeWeb";
    ReservationOrigin["webWidget"] = "webWidget";
    ReservationOrigin["facebookTab"] = "facebookTab";
})(ReservationOrigin || (exports.ReservationOrigin = ReservationOrigin = {}));
//# sourceMappingURL=ReservationOrigin.js.map